/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptStaffInviteDto,
  AssignRoleDto,
  BulkWorkingHoursDto,
  BulkWorkingHoursResponse,
  InviteStaffDto,
  SeatUsageResponse,
  SetPermissionOverridesDto,
  SetRevenueShareDto,
  SetStaffBranchesDto,
  StaffBranchesResponse,
  StaffInviteCreatedResponse,
  StaffInviteResponse,
  StaffList200,
  StaffListParams,
  StaffResponse,
  UpdateStaffDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * صندلی‌های مصرف‌شده و سقف پلن. دعوت‌های در انتظار هم صندلی اشغال می‌کنند، وگرنه می‌شد ده دعوت هم‌زمان روی پلن سه‌نفره فرستاد. سقف -۱ یعنی نامحدود.
 * @summary ظرفیت کاربران پلن
 */
export const staffSeatUsage = (

 signal?: AbortSignal
) => {


      return apiClient<SeatUsageResponse>(
      {url: `/api/v1/staff/seat-usage`, method: 'GET', signal
    },
      );
    }




export const getStaffSeatUsageQueryKey = () => {
    return [
    `/api/v1/staff/seat-usage`
    ] as const;
    }


export const getStaffSeatUsageQueryOptions = <TData = Awaited<ReturnType<typeof staffSeatUsage>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffSeatUsage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStaffSeatUsageQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof staffSeatUsage>>> = ({ signal }) => staffSeatUsage(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof staffSeatUsage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StaffSeatUsageQueryResult = NonNullable<Awaited<ReturnType<typeof staffSeatUsage>>>
export type StaffSeatUsageQueryError = unknown


export function useStaffSeatUsage<TData = Awaited<ReturnType<typeof staffSeatUsage>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffSeatUsage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof staffSeatUsage>>,
          TError,
          Awaited<ReturnType<typeof staffSeatUsage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStaffSeatUsage<TData = Awaited<ReturnType<typeof staffSeatUsage>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffSeatUsage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof staffSeatUsage>>,
          TError,
          Awaited<ReturnType<typeof staffSeatUsage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStaffSeatUsage<TData = Awaited<ReturnType<typeof staffSeatUsage>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffSeatUsage>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ظرفیت کاربران پلن
 */

export function useStaffSeatUsage<TData = Awaited<ReturnType<typeof staffSeatUsage>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffSeatUsage>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStaffSeatUsageQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * شمارهٔ دعوت‌شده به شکل پوشیده برمی‌گردد، چون ممکن است هرگز عضو کلینیک نشود.
 * @summary فهرست دعوت‌ها
 */
export const staffListInvites = (

 signal?: AbortSignal
) => {


      return apiClient<StaffInviteResponse[]>(
      {url: `/api/v1/staff/invites`, method: 'GET', signal
    },
      );
    }




export const getStaffListInvitesQueryKey = () => {
    return [
    `/api/v1/staff/invites`
    ] as const;
    }


export const getStaffListInvitesQueryOptions = <TData = Awaited<ReturnType<typeof staffListInvites>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffListInvites>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStaffListInvitesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof staffListInvites>>> = ({ signal }) => staffListInvites(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof staffListInvites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StaffListInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof staffListInvites>>>
export type StaffListInvitesQueryError = unknown


export function useStaffListInvites<TData = Awaited<ReturnType<typeof staffListInvites>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffListInvites>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof staffListInvites>>,
          TError,
          Awaited<ReturnType<typeof staffListInvites>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStaffListInvites<TData = Awaited<ReturnType<typeof staffListInvites>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffListInvites>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof staffListInvites>>,
          TError,
          Awaited<ReturnType<typeof staffListInvites>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStaffListInvites<TData = Awaited<ReturnType<typeof staffListInvites>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffListInvites>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست دعوت‌ها
 */

export function useStaffListInvites<TData = Awaited<ReturnType<typeof staffListInvites>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffListInvites>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStaffListInvitesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * اگر این شماره حساب کاربری نداشته باشد ساخته می‌شود، عضویت همکار در کلینیک بلافاصله فعال می‌شود و کد پیوستن پیامک می‌گردد. چون ورود در بوکورا فقط با پیامک است، همکار با همان شمارهٔ خودش وارد می‌شود و کد فقط نقش رسید تأیید را دارد. اگر ارسال پیامک ناموفق باشد، عضویت باقی می‌ماند و smsDelivered برابر false برمی‌گردد.
 * @summary دعوت همکار با شمارهٔ موبایل
 */
export const staffInvite = (
    inviteStaffDto: InviteStaffDto,
 signal?: AbortSignal
) => {


      return apiClient<StaffInviteCreatedResponse>(
      {url: `/api/v1/staff/invites`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteStaffDto, signal
    },
      );
    }




export const getStaffInviteMutationKey = () => ['staffInvite'] as const;

export const getStaffInviteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffInvite>>, TError,StaffInviteMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof staffInvite>>, TError,StaffInviteMutationVariables, TContext> => {

const mutationKey = getStaffInviteMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof staffInvite>>, StaffInviteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  staffInvite(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StaffInviteMutationResult = NonNullable<Awaited<ReturnType<typeof staffInvite>>>
    export type StaffInviteMutationBody = InviteStaffDto
    export type StaffInviteMutationError = void
    export type StaffInviteMutationVariables = {data: InviteStaffDto}

    /**
 * @summary دعوت همکار با شمارهٔ موبایل
 */
export const useStaffInvite = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffInvite>>, TError,StaffInviteMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof staffInvite>>,
        TError,
        StaffInviteMutationVariables,
        TContext
      > => {
      return useMutation(getStaffInviteMutationOptions(options), queryClient);
    }
    /**
 * از حساب خودِ دعوت‌شده صدا زده می‌شود و دعوت را «پذیرفته‌شده» علامت می‌زند. عضویت را نمی‌سازد و دسترسی تازه‌ای نمی‌دهد؛ عضویت را کلینیک هنگام دعوت ساخته است.
 * @summary تأیید دعوت با کد پیامک‌شده
 */
export const staffAcceptInvite = (
    acceptStaffInviteDto: AcceptStaffInviteDto,
 signal?: AbortSignal
) => {


      return apiClient<StaffInviteResponse>(
      {url: `/api/v1/staff/invites/accept`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: acceptStaffInviteDto, signal
    },
      );
    }




export const getStaffAcceptInviteMutationKey = () => ['staffAcceptInvite'] as const;

export const getStaffAcceptInviteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffAcceptInvite>>, TError,StaffAcceptInviteMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof staffAcceptInvite>>, TError,StaffAcceptInviteMutationVariables, TContext> => {

const mutationKey = getStaffAcceptInviteMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof staffAcceptInvite>>, StaffAcceptInviteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  staffAcceptInvite(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StaffAcceptInviteMutationResult = NonNullable<Awaited<ReturnType<typeof staffAcceptInvite>>>
    export type StaffAcceptInviteMutationBody = AcceptStaffInviteDto
    export type StaffAcceptInviteMutationError = void
    export type StaffAcceptInviteMutationVariables = {data: AcceptStaffInviteDto}

    /**
 * @summary تأیید دعوت با کد پیامک‌شده
 */
export const useStaffAcceptInvite = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffAcceptInvite>>, TError,StaffAcceptInviteMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof staffAcceptInvite>>,
        TError,
        StaffAcceptInviteMutationVariables,
        TContext
      > => {
      return useMutation(getStaffAcceptInviteMutationOptions(options), queryClient);
    }
    /**
 * کد تازه‌ای می‌سازد، مهلت هفت‌روزه را از نو شروع می‌کند و کد قبلی را باطل می‌کند. دعوتِ منقضی‌شده هم دوباره فرستاده می‌شود؛ اگر همکار فعالی پشت آن شماره نباشد، اول ظرفیت پلن بررسی می‌شود. دعوت پذیرفته‌شده یا لغوشده دوباره فرستاده نمی‌شود.
 * @summary ارسال دوبارهٔ کد دعوت
 */
export const staffResendInvite = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<StaffInviteResponse>(
      {url: `/api/v1/staff/invites/${id}/resend`, method: 'POST', signal
    },
      );
    }




export const getStaffResendInviteMutationKey = () => ['staffResendInvite'] as const;

export const getStaffResendInviteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffResendInvite>>, TError,StaffResendInviteMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof staffResendInvite>>, TError,StaffResendInviteMutationVariables, TContext> => {

const mutationKey = getStaffResendInviteMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof staffResendInvite>>, StaffResendInviteMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  staffResendInvite(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StaffResendInviteMutationResult = NonNullable<Awaited<ReturnType<typeof staffResendInvite>>>

    export type StaffResendInviteMutationError = void
    export type StaffResendInviteMutationVariables = {id: string}

    /**
 * @summary ارسال دوبارهٔ کد دعوت
 */
export const useStaffResendInvite = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffResendInvite>>, TError,StaffResendInviteMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof staffResendInvite>>,
        TError,
        StaffResendInviteMutationVariables,
        TContext
      > => {
      return useMutation(getStaffResendInviteMutationOptions(options), queryClient);
    }
    /**
 * دعوت را باطل می‌کند و اگر همکار هنوز آن را تأیید نکرده باشد، عضویتی که با همین دعوت ساخته شده بود غیرفعال می‌شود. عضویت تأییدشده از این مسیر دست نمی‌خورد.
 * @summary لغو دعوت
 */
export const staffRevokeInvite = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/staff/invites/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getStaffRevokeInviteMutationKey = () => ['staffRevokeInvite'] as const;

export const getStaffRevokeInviteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffRevokeInvite>>, TError,StaffRevokeInviteMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof staffRevokeInvite>>, TError,StaffRevokeInviteMutationVariables, TContext> => {

const mutationKey = getStaffRevokeInviteMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof staffRevokeInvite>>, StaffRevokeInviteMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  staffRevokeInvite(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StaffRevokeInviteMutationResult = NonNullable<Awaited<ReturnType<typeof staffRevokeInvite>>>

    export type StaffRevokeInviteMutationError = void
    export type StaffRevokeInviteMutationVariables = {id: string}

    /**
 * @summary لغو دعوت
 */
export const useStaffRevokeInvite = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffRevokeInvite>>, TError,StaffRevokeInviteMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof staffRevokeInvite>>,
        TError,
        StaffRevokeInviteMutationVariables,
        TContext
      > => {
      return useMutation(getStaffRevokeInviteMutationOptions(options), queryClient);
    }
    /**
 * همکاران فعال اول، سپس غیرفعال‌ها. هر ردیف نقش، دسترسی‌های مؤثر و اعطا/سلب‌های اختصاصی را همراه دارد تا ویرایشگر نقش بتواند تفاوت «نقش این را می‌دهد» و «به این نفر جداگانه داده شده» را نشان دهد.
 * @summary فهرست همکاران
 */
export const staffList = (
    params?: StaffListParams,
 signal?: AbortSignal
) => {


      return apiClient<StaffList200>(
      {url: `/api/v1/staff`, method: 'GET',
        params, signal
    },
      );
    }




export const getStaffListQueryKey = (params?: StaffListParams,) => {
    return [
    `/api/v1/staff`, ...(params ? [params] : [])
    ] as const;
    }


export const getStaffListQueryOptions = <TData = Awaited<ReturnType<typeof staffList>>, TError = unknown>(params?: StaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStaffListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof staffList>>> = ({ signal }) => staffList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof staffList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StaffListQueryResult = NonNullable<Awaited<ReturnType<typeof staffList>>>
export type StaffListQueryError = unknown


export function useStaffList<TData = Awaited<ReturnType<typeof staffList>>, TError = unknown>(
 params: undefined |  StaffListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof staffList>>,
          TError,
          Awaited<ReturnType<typeof staffList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStaffList<TData = Awaited<ReturnType<typeof staffList>>, TError = unknown>(
 params?: StaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof staffList>>,
          TError,
          Awaited<ReturnType<typeof staffList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStaffList<TData = Awaited<ReturnType<typeof staffList>>, TError = unknown>(
 params?: StaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست همکاران
 */

export function useStaffList<TData = Awaited<ReturnType<typeof staffList>>, TError = unknown>(
 params?: StaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStaffListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary یک همکار
 */
export const staffGet = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<StaffResponse>(
      {url: `/api/v1/staff/${id}`, method: 'GET', signal
    },
      );
    }




export const getStaffGetQueryKey = (id: string,) => {
    return [
    `/api/v1/staff/${id}`
    ] as const;
    }


export const getStaffGetQueryOptions = <TData = Awaited<ReturnType<typeof staffGet>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStaffGetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof staffGet>>> = ({ signal }) => staffGet(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof staffGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StaffGetQueryResult = NonNullable<Awaited<ReturnType<typeof staffGet>>>
export type StaffGetQueryError = void


export function useStaffGet<TData = Awaited<ReturnType<typeof staffGet>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof staffGet>>,
          TError,
          Awaited<ReturnType<typeof staffGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStaffGet<TData = Awaited<ReturnType<typeof staffGet>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof staffGet>>,
          TError,
          Awaited<ReturnType<typeof staffGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStaffGet<TData = Awaited<ReturnType<typeof staffGet>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary یک همکار
 */

export function useStaffGet<TData = Awaited<ReturnType<typeof staffGet>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof staffGet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStaffGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * نام نمایشی، عنوان، تخصص، شمارهٔ نظام، معرفی، تصویر و نمایش در صفحهٔ عمومی. سهم درآمد و حقوق از این مسیر تغییر نمی‌کند و دسترسی جداگانه دارد.
 * @summary ویرایش مشخصات همکار
 */
export const staffUpdate = (
    id: string,
    updateStaffDto: UpdateStaffDto,
 signal?: AbortSignal
) => {


      return apiClient<StaffResponse>(
      {url: `/api/v1/staff/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateStaffDto, signal
    },
      );
    }




export const getStaffUpdateMutationKey = () => ['staffUpdate'] as const;

export const getStaffUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffUpdate>>, TError,StaffUpdateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof staffUpdate>>, TError,StaffUpdateMutationVariables, TContext> => {

const mutationKey = getStaffUpdateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof staffUpdate>>, StaffUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  staffUpdate(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StaffUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof staffUpdate>>>
    export type StaffUpdateMutationBody = UpdateStaffDto
    export type StaffUpdateMutationError = void
    export type StaffUpdateMutationVariables = {id: string;data: UpdateStaffDto}

    /**
 * @summary ویرایش مشخصات همکار
 */
export const useStaffUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffUpdate>>, TError,StaffUpdateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof staffUpdate>>,
        TError,
        StaffUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getStaffUpdateMutationOptions(options), queryClient);
    }
    /**
 * عضویت به سطل بازیافت می‌رود؛ سوابق بالینی حذف نمی‌شوند و ارجاع‌ها معتبر می‌مانند. آخرین مالک کلینیک قابل حذف نیست.
 * @summary حذف همکار
 */
export const staffRemove = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/staff/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getStaffRemoveMutationKey = () => ['staffRemove'] as const;

export const getStaffRemoveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffRemove>>, TError,StaffRemoveMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof staffRemove>>, TError,StaffRemoveMutationVariables, TContext> => {

const mutationKey = getStaffRemoveMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof staffRemove>>, StaffRemoveMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  staffRemove(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StaffRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof staffRemove>>>

    export type StaffRemoveMutationError = void
    export type StaffRemoveMutationVariables = {id: string}

    /**
 * @summary حذف همکار
 */
export const useStaffRemove = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffRemove>>, TError,StaffRemoveMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof staffRemove>>,
        TError,
        StaffRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getStaffRemoveMutationOptions(options), queryClient);
    }
    /**
 * فهرست کامل شعبه‌های این همکار را جایگزین می‌کند (دست‌کم یکی). کسی که «دسترسی به همهٔ شعبه‌ها» ندارد فقط تقویم، جلسات، صندوق و انبار همین شعبه‌ها را می‌بیند.
 * @summary شعبه‌های محل کار همکار
 */
export const staffSetBranches = (
    id: string,
    setStaffBranchesDto: SetStaffBranchesDto,
 signal?: AbortSignal
) => {


      return apiClient<StaffBranchesResponse>(
      {url: `/api/v1/staff/${id}/branches`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setStaffBranchesDto, signal
    },
      );
    }




export const getStaffSetBranchesMutationKey = () => ['staffSetBranches'] as const;

export const getStaffSetBranchesMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffSetBranches>>, TError,StaffSetBranchesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof staffSetBranches>>, TError,StaffSetBranchesMutationVariables, TContext> => {

const mutationKey = getStaffSetBranchesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof staffSetBranches>>, StaffSetBranchesMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  staffSetBranches(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StaffSetBranchesMutationResult = NonNullable<Awaited<ReturnType<typeof staffSetBranches>>>
    export type StaffSetBranchesMutationBody = SetStaffBranchesDto
    export type StaffSetBranchesMutationError = void
    export type StaffSetBranchesMutationVariables = {id: string;data: SetStaffBranchesDto}

    /**
 * @summary شعبه‌های محل کار همکار
 */
export const useStaffSetBranches = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffSetBranches>>, TError,StaffSetBranchesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof staffSetBranches>>,
        TError,
        StaffSetBranchesMutationVariables,
        TContext
      > => {
      return useMutation(getStaffSetBranchesMutationOptions(options), queryClient);
    }
    /**
 * نقش پیش‌فرض سامانه یا نقش سفارشی همین کلینیک. توکن‌های فعال این کاربر بلافاصله بی‌اعتبار می‌شوند تا تغییر دسترسی همان لحظه اعمال شود.
 * @summary تغییر نقش همکار
 */
export const staffAssignRole = (
    id: string,
    assignRoleDto: AssignRoleDto,
 signal?: AbortSignal
) => {


      return apiClient<StaffResponse>(
      {url: `/api/v1/staff/${id}/role`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: assignRoleDto, signal
    },
      );
    }




export const getStaffAssignRoleMutationKey = () => ['staffAssignRole'] as const;

export const getStaffAssignRoleMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffAssignRole>>, TError,StaffAssignRoleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof staffAssignRole>>, TError,StaffAssignRoleMutationVariables, TContext> => {

const mutationKey = getStaffAssignRoleMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof staffAssignRole>>, StaffAssignRoleMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  staffAssignRole(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StaffAssignRoleMutationResult = NonNullable<Awaited<ReturnType<typeof staffAssignRole>>>
    export type StaffAssignRoleMutationBody = AssignRoleDto
    export type StaffAssignRoleMutationError = void
    export type StaffAssignRoleMutationVariables = {id: string;data: AssignRoleDto}

    /**
 * @summary تغییر نقش همکار
 */
export const useStaffAssignRole = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffAssignRole>>, TError,StaffAssignRoleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof staffAssignRole>>,
        TError,
        StaffAssignRoleMutationVariables,
        TContext
      > => {
      return useMutation(getStaffAssignRoleMutationOptions(options), queryClient);
    }
    /**
 * اعطا و سلب روی نقش. هر دو فهرست به‌طور کامل جایگزین می‌شوند. سلب بر اعطا اولویت دارد، پس دسترسی سلب‌شده با ویرایش بعدی نقش برنمی‌گردد.
 * @summary تنظیم دسترسی‌های اختصاصی همکار
 */
export const staffSetPermissions = (
    id: string,
    setPermissionOverridesDto: SetPermissionOverridesDto,
 signal?: AbortSignal
) => {


      return apiClient<StaffResponse>(
      {url: `/api/v1/staff/${id}/permissions`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setPermissionOverridesDto, signal
    },
      );
    }




export const getStaffSetPermissionsMutationKey = () => ['staffSetPermissions'] as const;

export const getStaffSetPermissionsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffSetPermissions>>, TError,StaffSetPermissionsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof staffSetPermissions>>, TError,StaffSetPermissionsMutationVariables, TContext> => {

const mutationKey = getStaffSetPermissionsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof staffSetPermissions>>, StaffSetPermissionsMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  staffSetPermissions(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StaffSetPermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof staffSetPermissions>>>
    export type StaffSetPermissionsMutationBody = SetPermissionOverridesDto
    export type StaffSetPermissionsMutationError = void
    export type StaffSetPermissionsMutationVariables = {id: string;data: SetPermissionOverridesDto}

    /**
 * @summary تنظیم دسترسی‌های اختصاصی همکار
 */
export const useStaffSetPermissions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffSetPermissions>>, TError,StaffSetPermissionsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof staffSetPermissions>>,
        TError,
        StaffSetPermissionsMutationVariables,
        TContext
      > => {
      return useMutation(getStaffSetPermissionsMutationOptions(options), queryClient);
    }
    /**
 * سهم به bp ذخیره می‌شود (۱٪ = ۱۰۰) و حقوق پایه به ریال صحیح، تا محاسبهٔ پورسانت تا آخر عدد صحیح بماند.
 * @summary تنظیم سهم درآمد و حقوق پایه
 */
export const staffSetRevenueShare = (
    id: string,
    setRevenueShareDto: SetRevenueShareDto,
 signal?: AbortSignal
) => {


      return apiClient<StaffResponse>(
      {url: `/api/v1/staff/${id}/revenue-share`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: setRevenueShareDto, signal
    },
      );
    }




export const getStaffSetRevenueShareMutationKey = () => ['staffSetRevenueShare'] as const;

export const getStaffSetRevenueShareMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffSetRevenueShare>>, TError,StaffSetRevenueShareMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof staffSetRevenueShare>>, TError,StaffSetRevenueShareMutationVariables, TContext> => {

const mutationKey = getStaffSetRevenueShareMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof staffSetRevenueShare>>, StaffSetRevenueShareMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  staffSetRevenueShare(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StaffSetRevenueShareMutationResult = NonNullable<Awaited<ReturnType<typeof staffSetRevenueShare>>>
    export type StaffSetRevenueShareMutationBody = SetRevenueShareDto
    export type StaffSetRevenueShareMutationError = void
    export type StaffSetRevenueShareMutationVariables = {id: string;data: SetRevenueShareDto}

    /**
 * @summary تنظیم سهم درآمد و حقوق پایه
 */
export const useStaffSetRevenueShare = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffSetRevenueShare>>, TError,StaffSetRevenueShareMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof staffSetRevenueShare>>,
        TError,
        StaffSetRevenueShareMutationVariables,
        TContext
      > => {
      return useMutation(getStaffSetRevenueShareMutationOptions(options), queryClient);
    }
    /**
 * دسترسی همکار به این کلینیک بسته می‌شود ولی همهٔ سوابق بالینی او دست‌نخورده می‌ماند. آخرین مالک کلینیک را نمی‌توان غیرفعال کرد.
 * @summary غیرفعال کردن همکار
 */
export const staffDeactivate = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<StaffResponse>(
      {url: `/api/v1/staff/${id}/deactivate`, method: 'POST', signal
    },
      );
    }




export const getStaffDeactivateMutationKey = () => ['staffDeactivate'] as const;

export const getStaffDeactivateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffDeactivate>>, TError,StaffDeactivateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof staffDeactivate>>, TError,StaffDeactivateMutationVariables, TContext> => {

const mutationKey = getStaffDeactivateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof staffDeactivate>>, StaffDeactivateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  staffDeactivate(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StaffDeactivateMutationResult = NonNullable<Awaited<ReturnType<typeof staffDeactivate>>>

    export type StaffDeactivateMutationError = void
    export type StaffDeactivateMutationVariables = {id: string}

    /**
 * @summary غیرفعال کردن همکار
 */
export const useStaffDeactivate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffDeactivate>>, TError,StaffDeactivateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof staffDeactivate>>,
        TError,
        StaffDeactivateMutationVariables,
        TContext
      > => {
      return useMutation(getStaffDeactivateMutationOptions(options), queryClient);
    }
    /**
 * یک صندلی از ظرفیت پلن مصرف می‌کند، پس اگر ظرفیت پر باشد پذیرفته نمی‌شود.
 * @summary فعال کردن دوبارهٔ همکار
 */
export const staffActivate = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<StaffResponse>(
      {url: `/api/v1/staff/${id}/activate`, method: 'POST', signal
    },
      );
    }




export const getStaffActivateMutationKey = () => ['staffActivate'] as const;

export const getStaffActivateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffActivate>>, TError,StaffActivateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof staffActivate>>, TError,StaffActivateMutationVariables, TContext> => {

const mutationKey = getStaffActivateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof staffActivate>>, StaffActivateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  staffActivate(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StaffActivateMutationResult = NonNullable<Awaited<ReturnType<typeof staffActivate>>>

    export type StaffActivateMutationError = void
    export type StaffActivateMutationVariables = {id: string}

    /**
 * @summary فعال کردن دوبارهٔ همکار
 */
export const useStaffActivate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffActivate>>, TError,StaffActivateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof staffActivate>>,
        TError,
        StaffActivateMutationVariables,
        TContext
      > => {
      return useMutation(getStaffActivateMutationOptions(options), queryClient);
    }
    /**
 * همهٔ شیفت‌های همکاران انتخاب‌شده در روزهای انتخاب‌شده با همین یک شیفت (و استراحت‌هایش) جایگزین می‌شود؛ روزهای دیگرشان دست نمی‌خورد. همه در یک تراکنش: یا برای همه ثبت می‌شود یا برای هیچ‌کس.
 * @summary ثبت یک برنامهٔ کاری برای چند همکار و چند روز
 */
export const staffWorkingHoursApplyBulk = (
    bulkWorkingHoursDto: BulkWorkingHoursDto,
 signal?: AbortSignal
) => {


      return apiClient<BulkWorkingHoursResponse>(
      {url: `/api/v1/staff/working-hours/bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkWorkingHoursDto, signal
    },
      );
    }




export const getStaffWorkingHoursApplyBulkMutationKey = () => ['staffWorkingHoursApplyBulk'] as const;

export const getStaffWorkingHoursApplyBulkMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffWorkingHoursApplyBulk>>, TError,StaffWorkingHoursApplyBulkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof staffWorkingHoursApplyBulk>>, TError,StaffWorkingHoursApplyBulkMutationVariables, TContext> => {

const mutationKey = getStaffWorkingHoursApplyBulkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof staffWorkingHoursApplyBulk>>, StaffWorkingHoursApplyBulkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  staffWorkingHoursApplyBulk(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StaffWorkingHoursApplyBulkMutationResult = NonNullable<Awaited<ReturnType<typeof staffWorkingHoursApplyBulk>>>
    export type StaffWorkingHoursApplyBulkMutationBody = BulkWorkingHoursDto
    export type StaffWorkingHoursApplyBulkMutationError = void
    export type StaffWorkingHoursApplyBulkMutationVariables = {data: BulkWorkingHoursDto}

    /**
 * @summary ثبت یک برنامهٔ کاری برای چند همکار و چند روز
 */
export const useStaffWorkingHoursApplyBulk = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof staffWorkingHoursApplyBulk>>, TError,StaffWorkingHoursApplyBulkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof staffWorkingHoursApplyBulk>>,
        TError,
        StaffWorkingHoursApplyBulkMutationVariables,
        TContext
      > => {
      return useMutation(getStaffWorkingHoursApplyBulkMutationOptions(options), queryClient);
    }
